import { z } from 'zod';

export type Product = z.infer<typeof ProductSchema>;
export const ProductSchema = z.object({
  id: z.string().nonempty("Product ID is required."),
  name: z.string().nonempty("Product name is required."),
  price: z.number().min(0.01, "Price must be at least 0.01.").optional(),
  imageUrl: z.string().url("Product image url is required.").optional()
});

export type ProductSummary = z.infer<typeof ProductSummarySchema>;
export const ProductSummarySchema = z.object({
  name: z.string().nonempty("Product name is required."),
  description: z.string().nonempty("Product description is required."),
  imageUrl: z.string().optional(),
  price: z.number().min(0.01, "Price must be at least 0.01.").optional()
});